import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import * as stringFormat from 'string-format';
import {WebConfigurationService} from '../web-configuration-module/web-configuration.service';

export enum HttpMethod {
  get = 'get', post = 'post', put = 'put', delete = 'delete'
}

export abstract class BaseService {
  static STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
  static ARGUMENT_NAMES = /([^\s,]+)/g;

  protected constructor(
    protected http: HttpClient, protected configurationService: WebConfigurationService, protected path: string, protected root: string) {
  }

  exec(method: HttpMethod, mapping: string, func: any, args: any[], format = 'json'): Observable<any> {
    const paramNames = this.getParamNames(func);

    const map = {};
    let body = null;
    // tslint:disable-next-line:forin
    for (const idx in args) {
      const paramName = paramNames[idx];
      const value = args[idx];
      if (!this.isObject(value) || this.isDate(value)) {
        map[paramName] = value;
      } else {
        body = value;
      }
    }

    const mappingPath = this.root + stringFormat(this.path + mapping, map);
    if (method === HttpMethod.get || method === HttpMethod.delete) {
      return this.http[HttpMethod[method]](mappingPath);
    } else if (method === HttpMethod.post || method === HttpMethod.put) {
      return this.http[HttpMethod[method]](mappingPath, body);
    }

    return null;
  }


  getParamNames(func): string[] {
    const fnStr = func.toString().replace(BaseService.STRIP_COMMENTS, '');
    let result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(BaseService.ARGUMENT_NAMES);
    if (result === null) {
      result = [];
    }
    return result;
  }

  isObject(arg) {
    return typeof arg === 'object' && arg !== null;
  }

  isDate(d) {
    return this.isObject(d) && this.objectToString(d) === '[object Date]';
  }

  isError(e) {
    return this.isObject(e) &&
      (this.objectToString(e) === '[object Error]' || e instanceof Error);
  }

  isFunction(arg) {
    return typeof arg === 'function';
  }

  objectToString(o) {
    return Object.prototype.toString.call(o);
  }
}
